/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import ColorPicker from "../ColorPicker.vue";
import { useDtfStore } from "../store";
import "./Color.scss";

export default function Color({ ...restProps }) {
  const colors = [
    {
      name: "Black",
      value: "#000000"
    },
    {
      name: "White",
      value: "#FFFFFF"
    },
    {
      name: "Navy",
      value: "#03283A"
    },
    {
      name: "Red",
      value: "#D50132"
    },
    {
      name: "Gold",
      value: "#FCA311"
    },
    {
      name: "Green",
      value: "#016B3F"
    },
    {
      name: "Purple",
      value: "#514689"
    },
    {
      name: "Royal",
      value: "#082D99"
    },
    {
      name: "Gray",
      value: "#82878D"
    },
    {
      name: "Columbia",
      value: "#6887B7"
    },
    {
      name: "Orange",
      value: "#F14329"
    },
    {
      name: "Vegas Gold",
      value: "#ABA275"
    },
    {
      name: "Yellow",
      value: "#F8DC02"
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function handleSelect(color: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      color
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.generateLettersPreview();
  }

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("color", restProps.className)}>
      <ColorPicker
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        value={letterNumberArtwork().color}
        colors={colors}
        showColorLabel={true}
        onChange={handleSelect}
        data-testid="color-picker"
      />
    </div>
  );
}
